<template>
  <section id="hiw__faqs--section">
    <div class="container">
      <div class="row">
        <div class="faq__header">
          <h3>FAQs</h3>
        </div>
      </div>

      <div class="faq__content">
        <ul
          v-for="(faqContainer, containerIndex) in splitFaqs"
          :key="containerIndex">
          <faq
            v-for="(faq, index) in faqContainer"
            :key="index"
            :question="faq.question"
            :answer="faq.answer"
          />
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { chunk } from 'lodash'
import Faq from '~/components/product-page/Faq'

export default {
  components: {
    Faq
  },
  props: {
    faqs: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  computed: {
    splitFaqs () {
      return chunk(this.faqs, Math.round(this.faqs.length / 2))
    }
  }
}
</script>

<style lang="scss" scoped>
.faq__header {
  h3 {
    font-size: 40px;
    margin-bottom: 15px;
    text-align: center;

    @media screen and (max-width: 800px) {
      font-size: 28px;
    }
  }
}

.faq__content {
  display: flex;
  flex-direction: row;
  width: 100%;
  margin: 0 auto;
  justify-content: space-between;

  @media screen and (max-width: 800px) {
    flex-direction: column;
  }

  ul {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    flex-direction: column;
    width: 48%;
    list-style: none;
    margin: 0px;
    padding: 0px;

    &:first-child {
      margin-right: 4%;
    }

    @media screen and (max-width: 800px) {
      width: 100%;

      &:first-child {
        margin-right: 0;
      }
    }
  }
}

#hiw__faqs--section {
  padding: 45px 90px 60px;

  @media screen and (max-width: 1200px) {
    padding: 45px 45px 60px;
  }

  @media screen and (max-width: 800px) {
    padding: 30px 30px 45px;
    margin: 0 auto;
    max-width: 600px;
  }
}
</style>
